export enum OrganizationContactColumnsKey {
  Name = 'Contact/FullName',
  Profile = 'ProfileTypeId',
  ProfilePrimaryEmail = 'PrimaryEmail',
  Status = 'ProfileStatusId'
}

export enum OrganizationAdvanceColumnsKey {
  Id = 'Id',
  Description = 'Description',
  AmountInitial = 'AmountInitial',
  PaidAmount = 'PaidAmount',
  PaybackRemainder = 'PaybackRemainder',
  AdvanceStatusId = 'AdvanceStatusId',
}

export enum OrganizationGarnisheeColumnsKey {
  Id = 'Id',
  Description = 'Description',
  PayAmountMaximum = 'PayAmountMaximum',
  PaidAmount = 'PaidAmount',
  PaybackRemainder = 'PaybackRemainder',
  GarnisheeStatusId = 'GarnisheeStatusId',
  PayAmountIsMaximum = 'PayAmountIsMaximum',
  CurrencyCode = 'CurrencyCode'
}

export enum OrganizationNumberValidationType {
  BusinessNumber = 1,
  EmployerIdentificationNumber = 2,
  TaxNumber = 3
}
